import { useState } from 'react';
import { TextField, Button, Typography, Box } from '@mui/material';
import { API } from 'aws-amplify';
import { updateVideoData as updateVideoMutation } from '../../graphql/mutations';

export const CrossStartUpdater = ({
  liftSelectedSession,
  selectedSession,
  combinedStates,
}) => {
  const [startTimeHasChanged, setStartTimeHasChanged] = useState(false);

  function handleCrossStartUpdate(e) {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    const body = {};
    for (const [key, value] of form.entries()) {
      body[key] = value;
    }
    const xs = Number(body['cross-start-name']);
    liftSelectedSession((s) => ({ ...s, crossStart: xs }));
    setStartTimeHasChanged(true);
  }

  function commitCrossStartUpdate() {
    const recObj = selectedSession;
    const changeObj = { crossStart: selectedSession.crossStart };
    updateVideoEntry(recObj, changeObj);
  }

  async function updateVideoEntry(vid_record_obj, change_obj) {
    const videoUpdates = {
      id: vid_record_obj.videoTableRecordId,
      _version: vid_record_obj.videoTableRecordVersion,
      ...change_obj,
    };
    try {
      const updatedVidRecord = await API.graphql({
        query: updateVideoMutation,
        variables: { input: videoUpdates },
      });
      setStartTimeHasChanged(false);
      return updatedVidRecord;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <form onSubmit={handleCrossStartUpdate}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          columnGap: '20px',
        }}
      >
        <Typography component="div">Adjust Cross Startline Time:</Typography>
        <Typography component="div">
          Current Time:{combinedStates.videoCurrentTime}
        </Typography>
        <TextField
          id="cross-start"
          name="cross-start-name"
          label={selectedSession.crossStart}
          size="small"
        />
        <Button size="small" type="submit" variant="outlined">
          Update
        </Button>
        {startTimeHasChanged && (
          <>
            <Button size="small" onClick={commitCrossStartUpdate}>
              Commit Change
            </Button>
            <Button size="small" onClick={commitCrossStartUpdate}>
              Cancel
            </Button>
          </>
        )}
      </Box>
    </form>
  );
};
